const s = {
  name: "PosTestingTools",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M22,2h-3V0h3c1.7,0,3,1.3,3,3h15v18H25v3c0,1.7-1.3,3-3,3h-4c-1.7,0-3-1.3-3-3v-3H2v14h13c0-1.7,1.3-3,3-3h3
			v2h-3c-0.5,0-1,0.5-1,1v2c0,0.5,0.5,1,1,1h3v2h-3c-1.7,0-3-1.3-3-3H0V19h15v-3c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v3h13V5H25
			c0,1.7-1.3,3-3,3h-3V6h3c0.5,0,1-0.5,1-1V3C23,2.5,22.5,2,22,2z M23,16c0-0.6-0.4-1-1-1h-4c-0.6,0-1,0.4-1,1v3h6V16z M23,21h-6v3
			c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1V21z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as PosTestingTools
};
